import React from 'react';
import {Grid, Card, CardContent} from '@material-ui/core';
import {Layout, MainSection, DarkSection, Image, Container} from 'components';

import {imageCellphone, imageEnvelope, imageChat} from "../Plan/images"

import './styles.sass';

import FreshChat from 'react-freshchat'

function Terms(layoutProps: any): React.ReactElement {

    return (
        <Layout {...layoutProps}>
            <Grid
                container
                wrap="nowrap"
                direction="column"
                className="help-page"
            >
                <MainSection
                    title={<span>Customer service is at the <br className="text-tablet-width-breakpoint"/> heart of who we are at Mobi.</span>}
                    text={
                        <span>Our customer care team loves problem solving — we'll always strive to make things right.<br/> <br
                            className="text-tablet-width-breakpoint"/> Give us a call, text, or email us if there's anything we can do.</span>}
                >
                    <div className="help-card-wrapper">
                        <Grid container
                              direction="row"
                              justify="center"
                              alignItems="center"
                              spacing={4}
                              className="help-card-grid"
                        >
                            <Grid item sm={4} xs={12}>
                                <a href="tel:+18887231111">
                                    <Card className="help-card">
                                        <CardContent className="help-card-content">
                                            <div className="help-list-wrapper">
                                                <ul className="help-list">
                                                    <li className="item text-center justify-center flex-row">
                                                        <Image
                                                            src={imageCellphone}
                                                            alt="Call"
                                                            wrapperClassName="icon"
                                                        />
                                                    </li>
                                                    <li className="item text-center justify-center flex-row">
                                                        <h3>Call</h3>
                                                    </li>
                                                    <li className="item">
                                                        <span>808 723-1111</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </a>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <a href="mailto:help@mobi.com">
                                    <Card className="help-card">
                                        <CardContent className="help-card-content">
                                            <div className="help-list-wrapper">
                                                <ul className="help-list">
                                                    <li className="item text-center justify-center flex-row">
                                                        <Image
                                                            src={imageEnvelope}
                                                            alt="Email"
                                                            wrapperClassName="icon"
                                                        />
                                                    </li>
                                                    <li className="item text-center justify-center flex-row">
                                                        <h3>Email</h3>
                                                    </li>
                                                    <li className="item">
                                                        <span>help@mobi.com</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </a>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <a href="sms:+18087231111">
                                    <Card className="help-card">
                                        <CardContent className="help-card-content">
                                            <div className="help-list-wrapper">
                                                <ul className="help-list">
                                                    <li className="item text-center justify-center flex-row">
                                                        <Image
                                                            src={imageChat}
                                                            alt="Text"
                                                            wrapperClassName="icon"
                                                        />
                                                    </li>
                                                    <li className="item text-center justify-center flex-row">
                                                        <h3>Text</h3>
                                                    </li>
                                                    <li className="item">
                                                        <span>808 723-1111</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </a>
                            </Grid>
                        </Grid>
                    </div>
                </MainSection>
                <DarkSection>
                    <Container>
                        <div className="content">
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="center"
                                className="item"
                            >
                                <Grid item xs={12}>
                                    <h3 className="title">Our Care team is available Monday through Sunday from:</h3>
                                </Grid>
                                <Grid item xs={12}>
                                    <p className="description text-center">
                                        1am to 9pm Hawaiʻi Time (HST)<br/>
                                        3am to 11pm Alaska Daylight Time (AKDT)<br/>
                                        4am to midnight Pacific Daylight Time (PDT)<br/>
                                        5am to 1am Mountain Daylight Time (MDT)<br/>
                                        6am to 2am Central Daylight Time (CDT)<br/>
                                        7am to 3am Eastern Daylight Time and Puerto Rico (EDT)<br/>
                                        8am to 4am Atlantic Daylight Time (ADT)
                                    </p>
                                </Grid>
                                <Grid item xs={12}>
                                    <h3 className="title">On a legacy Mobi plan and need to pay your bill by mail?</h3>
                                </Grid>
                                <Grid item xs={12}>
                                    <p className="description text-center">
                                        Mobi, Inc.<br/>
                                        P.O. Box 4150<br/>
                                        Honolulu, Hawaiʻi 96812-4150
                                    </p>
                                </Grid>
                            </Grid>
                        </div>
                    </Container>
                </DarkSection>
            </Grid>
            <FreshChat
                token={process.env.REACT_APP_FRESHCHAT_KEY}
            />
        </Layout>
    );
}

export default Terms;
